export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9315.0bcfd110.jpg";